import Understanding from './Understanding'

export default Understanding
